<template>
  <div class='user-table'>
    <b-overlay
      :show='loading'
      rounded
      no-center
      opacity='0.7'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
    >
      <div class='inputs w-100 d-flex align-items-end justify-content-between mb-2'>
        <base-input-text
          block
          class=' ml-1 mt-1'
          v-model='email'
          placeholder='Pesquisar por email do usuário'
          type='text'
        />

        <base-input-text
          block
          class=' ml-1 mt-1'
          v-model='startDate'
          placeholder='Pesquisar por nome da empresa'
          type='date'
        />

        <base-input-text
          class=' ml-1'
          block
          v-model='endDate'
          placeholder='Pesquisar por nome do produto'
          type='date'
        />

        <base-button
          class='btn-pesquisar ml-1 mt-1'
          @click='applyFilters()'
        >
          Pesquisar
        </base-button>

        <base-button
          class='mx-1 btn-limpar-filtros mt-1'
          @click='resetFilters()'
        >
          Limpar filtros
        </base-button>
      </div>

      <base-table
        :columns='columns'
        :data='feedbacks'
        :total-items='feedbackMeta.total'
        :start-items='feedbackMeta.skip + 1'
        :max-items='feedbackMeta.limit'
        @set-page='pagination'
      >
        <template v-slot:body-files='row'>
          <a
            v-show="row.item.files && row.item.files.length > 0"
            v-for="(file, i) in row.item.files"
            :key="`${file._id}_${i}`"
            :href="file.url"
            target="_blank"
          >
            <span>{{file.fileName}}</span>
          </a>
          <span v-if="!row.item.files || row.item.files.length <= 0">-</span>
        </template>

        <template v-slot:body-emailsCc="row">
          <p
            class="mb-0"
            v-show="row.item.emailsCc && row.item.emailsCc.length > 0"
            v-for="(emailcc, i) in row.item.emailsCc"
            :key="`${emailcc}_${i}`"
          >
            {{emailcc}}
          </p>
          <span v-if="!row.item.emailsCc || row.item.emailsCc.length <= 0">-</span>
        </template>

        <template v-slot:body-createdAt='row'>
          {{formatDate(row.item.createdAt)}}
        </template>
      </base-table>

      <template v-slot:overlay>
        <div class='text-center loading-spinner'>
          <b-spinner style='width: 3rem; height: 3rem;' variant='primary' label='Large Spinner'></b-spinner>
          <h5 class='text-primary'>Buscando...</h5>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment/moment'

export default {
  name: 'FeedbackTable',
  data() {
    return {
      startDate: null,
      endDate: null,
      email: null,
      maximumIntervalBetweenDatesInMonths: 3.1,
      loading: false,
      columns: [
        { key: 'email', value: 'Email' },
        { key: 'message', value: 'Messagem' },
        { key: 'files', value: 'Arquivos' },
        { key: 'emailsCc', value: 'Emails em cópia' },
        { key: 'createdAt', value: 'Data do envio' }
      ],
    }
  },
  computed: {
    ...mapGetters('feedback', {
      feedbackMeta: 'feedbackMeta',
      feedbacks: 'feedbacks'
    }),
    errors() {
      return this.$store.getters['access/error']
    }
  },
  methods: {
    ...mapActions('reportsDownloads', {
      handleCreateReportDownloads: 'handleCreateReportDownloads'
    }),
    ...mapActions('feedback', {
      handlePaginatedList: 'handlePaginatedList',
      resetFilter: 'resetFilter',
    }),
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy: HH:mm:ss')
    },

    async applyFilters() {
      await this.listFeedbacks({
        startDate: this.startDate,
        endDate: this.endDate,
        email: this.email,
      })
    },

    async resetFilters() {
      this.startDate = null
      this.endDate = null
      this.email = null
      await this.resetFilter()
      await this.listFeedbacks({
        startDate: this.startDate,
        endDate: this.endDate,
        email: this.email,
      })
    },

    async pagination(page) {
      const pageCount = page <= 0 ? 1 : page
      const params = {
        skip: ((pageCount - 1) * this.feedbackMeta.limit),
        startDate: this.startDate,
        endDate: this.endDate,
        email: this.email,
      }
      await this.listFeedbacks(params)
    },

    async listFeedbacks(payload) {
      try {
        this.loading = true
        const params = {
          ...this.feedbackMeta,
          ...payload
        }

        await this.handlePaginatedList(params)
        this.loading = false
      } catch (e) {

      }
    }
  },
  async mounted() {
    await this.$store.dispatch('access/updateError', '')
    await this.resetFilters()
    await this.listFeedbacks(
      {
        startDate: this.startDate,
        endDate: this.endDate,
        email: this.email,
      }
    )
  },
  async created() {
  },
  watch: {}
}
</script>

<style lang='scss' scoped>
.inputs {
  .btn-data {
    max-width: 155px;
  }

  .btn-pesquisar {
    height: 48px;
    min-width: 105px;
  }

  .btn-limpar-filtros {
    min-width: 135px;
    height: 48px;
  }

  .link-export {
    text-decoration: none;
  }

  .btn-export {
    min-width: 190px;
    height: 48px;
  }
}

.loading-spinner {
  margin-top: 250px;
}
</style>
